import { render, staticRenderFns } from "./otherData.vue?vue&type=template&id=4aab1f1d&scoped=true&"
import script from "./otherData.vue?vue&type=script&lang=js&"
export * from "./otherData.vue?vue&type=script&lang=js&"
import style0 from "./otherData.vue?vue&type=style&index=0&id=4aab1f1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab1f1d",
  null
  
)

export default component.exports